import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {UpdateLogModel} from '@/libs/Api';
import {StoreName} from '@/libs/core/store/store-name';
import { UpdateLogsDataService } from '../update-logs-data-service';

export const updateLogsStore = registerCrudStore<UpdateLogModel, UpdateLogModel>(StoreName.UpdateLog, new UpdateLogsDataService());
